import React, { useContext, useEffect } from 'react'
import { useSections } from '@hooks/useSections'
import { groupBy } from '@helpers/utilities'
import { useFilteredItems } from '@hooks/useFilteredItems'
import Text from '@components/Text'
import Loader from '@components/Loader'
import SubjectSectionsGroup from '@components/SubjectSectionsGroup'
import { setFilteredItems } from '@state/actions/filtersActions'
import { AppContext } from '@state/context'
import { useLibrarySections } from '@hooks/useLibrarySections'

const LibrarySections = (props) => {
  const [, dispatch] = useContext(AppContext)
  const {
    sections,
    error: sectionsError,
    isLoading: isLoading,
  } = useLibrarySections()

  const filteredSections = useFilteredItems(sections)

  useEffect(() => {
    dispatch(setFilteredItems([...sections]))
  }, [sections])

  // Grouped by subject
  const sectionsBySubject = filteredSections.reduce((acc, item) => {
    if (item.subject.id in acc) {
      acc[item.subject.id].items.push(item)
    } else {
      acc[item.subject.id] = {
        subject: item.subject,
        items: [item],
      }
    }
    return acc
  }, {})

  return (
    <div className={'flex flex-col items-center justify-center'}>
      {sectionsError && <Text>Nåt gick fel när avsnitt skulle laddas</Text>}
      {!isLoading && !filteredSections.length && (
        <Text>Kunde inte hitta några avsnitt</Text>
      )}

      {Object.entries(sectionsBySubject).map(([key, group], index) => {
        return <SubjectSectionsGroup key={key} group={group} inLibraryView/>
      })}

      {isLoading && <Loader />}
    </div>
  )
}

export default LibrarySections
